import { axios } from '@/utils/request'

/**
 * 发送重置密码验证码
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.phoneNumber // 手机号码
 */
export const resetPasswordSendSms = data => {
  return axios({
    url: '/user/biz/student/pc/resetPasswordSendSms',
    method: 'POST',
    data
  })
}
/**
 * 短信验证码登录
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.phoneNumber // 手机号码
 * @param { String } data.smsCode // 短信验证码
 */
export const sendResetPasswordSmsCheck = data => {
  return axios({
    url: '/user/biz/student/pc/sendResetPasswordSmsCheck',
    method: 'POST',
    data
  })
}
/**
 * 重置密码
 * @param { Object } data
 * @param { String } data.password // 机构编码
 * @param { String } data.phoneNumber // 手机号码
 * @param { String } data.resetToken // 短信验证码
 */
 export const resetPassword = data => {
  return axios({
    url: '/user/biz/student/pc/resetPassword',
    method: 'POST',
    data
  })
}
